module.exports = __webpack_public_path__ + "assets/icons-misc-arrow-left-24-px.58df61a0.svg";